import React, { ReactElement, useEffect, useState } from "react";
import TencentCloudChat from "@tencentcloud/chat";
import { Avatar, Button, Image, Typography } from "antd";
import { formatShowTime } from "../../../utils/util";

import "./index.less";
import { ICustomPayloadDescription } from "@obsbot/remo-services";
import { useTranslate } from "@obsbot/remo-i18n";
import { eventBus } from "@obsbot/remo-utils";
import {
    CheckOutlined,
    CloseOutlined,
    ExclamationOutlined,
    LoadingOutlined,
} from "@ant-design/icons";
import { RouteNameType, RouteParams } from "@obsbot/remo-pages/src/utils/routes";
import {
    getPreferencesStore,
    globalStore,
    SpecialEffectTo,
    useChannelRoomStore,
    useChannelStore,
    useChatStore,
    useGlobalStore,
} from "@obsbot/remo-stores";
import { v4 as uuidv4 } from "uuid";
import {
    checkInviteURL,
    handleIntimate,
    reactionEmoji,
    REMO_GAME_WEB_URL,
} from "@obsbot/remo-server-api";
import { getRelationType } from "../ContactList";
import { useParams } from "react-router-dom";
// import { ChatType } from "../ChatSendInput";
// import { HoverMenu } from "./HoverMenu";
import { MsgDataProps } from ".";
import LoadFailPNG from "../icons/load-fail.png";
import { AcceptedIcon, RefusedIcon } from "../../SvgIconCom/ChatContentIcon";
export interface extensionProps {
    index: number;
    count: number;
    url?: string;
}

export enum PlaceHolderMsgType {
    MSG_PLACEHOLDER = "MSG_PLACEHOLDER",
}

interface MsgContentProps {
    // type: TencentCloudChat.TYPES | PlaceHolderMsgType;
    msg: any;
    msgData: MsgDataProps;
    basicInfo: {
        from: string;
        fromNick: string;
        to: string;
        flow: string;
    };
    hoverWindow?: boolean;
    isSearch?: boolean;
    pushHistory: <T extends RouteNameType>(name: T, params?: RouteParams<T>, state?: any) => void;
}
export const operationDesc = {
    1: (user: string) => `${user}申请加群`,
    2: (user: string) => `${user}的加群申请已通过`,
    3: (user: string) => `${user}的加群申请被拒绝`,
    4: (user: string) => `${user}被踢出群组`,
    5: (group: string) => `${group}群组已解散`,
    6: (group: string) => `${group}群组已创建`,
    7: (user: string) => `${user}邀请您加入群组`,
    8: (user: string) => `${user}已退出群组`,
    9: (user: string) => `${user}被设为管理员`,
    10: (user: string) => `${user}被取消管理员权限`,
    11: (group: string) => `${group}群组已被回收`,
    12: (user: string) => `收到${user}的加群邀请`,
    13: (user: string) => `${user}已接受您的邀请`,
    14: (user: string) => `${user}已拒绝您的邀请`,
    15: () => "已读状态已同步",
    16: (user: string, time?: number) => (time ? `${user}被禁言${time}分钟` : `${user}被取消禁言`),
    20: () => "消息提醒类型已同步",
    21: (user: string) => `${user}已被封禁`,
    22: (user: string) => `${user}已被解封`,
    23: (user: string, target: string) => `${user}邀请${target}加入群组`,
    255: (text: string) => text,
};

export const MsgContent: React.FC<MsgContentProps> = ({
    msg,
    basicInfo,
    hoverWindow,
    msgData,
    isSearch,
    pushHistory,
}) => {
    const { status, ID: msgID, payload, type } = msg;
    const t = useTranslate();
    const { userInfo } = useGlobalStore();
    const { blockedUsers } = useChannelRoomStore();
    const params = useParams();
    const { rtm, reactionList } = useChatStore();
    const [reaction, setReaction] = useState(reactionList?.get(msgID));

    let msgContent;
    // 亲密关系展示
    const getIntimateRelationContent = (): ReactElement => {
        let curInfo;
        try {
            curInfo = JSON.parse(payload.extension);
        } catch (error) {
            curInfo = {};
        }
        const { relationship, from = {}, to = {}, status: applyStatus } = curInfo;
        // applyStatus:  process、 refused、 accept、failed、expire
        const handleInvited = async (status: string): Promise<void> => {
            const msg = msgData.chatData.find(e => e.ID === msgID);
            if (!rtm) {
                eventBus.emit("show-message", {
                    message: "rtm error",
                    type: "error",
                });
            }
            let res;
            try {
                // 判断是确认添加还是确认变更
                res = await handleIntimate({
                    userId: to.userID,
                    friendId: from.userID,
                    relationType: getRelationType(relationship),
                    flag: status === "accept" ? 1 : 0, // 0-拒绝 1-同意
                    intimateRequestId: payload?.data ? Number(payload?.data) : undefined,
                });
            } catch (error) {
                res = error;
                console.log("error", error);
            }
            if (res.code === "200" && msg?.payload) {
                const tempExtension = JSON.parse(msg.payload.extension);
                msg.payload.extension = JSON.stringify({
                    ...tempExtension,
                    status: status,
                    time: formatShowTime(new Date().valueOf() / 1000),
                });
                // 修改自定义消息内容
                rtm?.handleRelationShipMsg(msg);
            } else if ((res.code === "RM.10032" || res.code === "RM.10036") && msg?.payload) {
                const tempExtension = JSON.parse(msg.payload.extension);
                msg.payload.extension = JSON.stringify({
                    ...tempExtension,
                    status: "expire",
                    time: formatShowTime(new Date().valueOf() / 1000),
                });
                // 修改自定义消息内容
                rtm?.handleRelationShipMsg(msg);
            }
        };

        return (
            <div className={`msg-content intimate-relation ${relationship}-${applyStatus}`}>
                <div className={"intimate-relation-avatar"}>
                    <Avatar className="relation-ship-avatar" size={24} src={from.avatar} />
                    <Avatar className="relation-ship-avatar" size={24} src={to.avatar} />
                </div>
                {applyStatus === "accept" ? (
                    <div className="intimate-relation-content accept">
                        <div className="relation-content-desc">
                            {t("relationship.success-desc")}
                            <span className={`relationship-${relationship}`}>
                                {t(`relationship.${relationship}`)}
                            </span>
                            {t("relationship.relationship")}
                        </div>
                        <div className="relation-action-status">
                            <CheckOutlined
                                style={{ margin: "0 5px" }}
                                onPointerMoveCapture={undefined}
                                onPointerOverCapture={undefined}
                            />
                            {t("relationship.status-accept")}
                        </div>
                    </div>
                ) : basicInfo.flow === "out" ? (
                    <div className="intimate-relation-content">
                        {applyStatus === "process" || applyStatus === "accept" ? (
                            <div className="relation-content-desc">
                                {t("relationship.invite-desc-from", { user: to.userName })}
                                <span className={`relationship-${relationship}`}>
                                    {t(`relationship.${relationship}`)}
                                </span>
                                {t("relationship.relationship")}
                            </div>
                        ) : (
                            <div className="relation-content-desc">
                                {t("relationship.establish")}
                                <span className={`relationship-${relationship}`}>
                                    {t(`relationship.${relationship}`)}
                                </span>
                                {t("relationship.desc-" + applyStatus)}
                            </div>
                        )}
                        <div className="relation-action-status">
                            {applyStatus === "accept" ? <AcceptedIcon /> : null}
                            {applyStatus === "refused" ? <RefusedIcon /> : null}
                            {t("relationship.status-" + applyStatus)}
                        </div>
                    </div>
                ) : (
                    <div className="intimate-relation-content">
                        {applyStatus === "process" || applyStatus === "accept" ? (
                            <div className="relation-content-desc">
                                {t("relationship.invite-desc")}
                                <span className={`relationship-${relationship}`}>
                                    {t(`relationship.${relationship}`)}
                                </span>
                                {t("relationship.relationship")}
                            </div>
                        ) : (
                            <div className="relation-content-desc">
                                {t("relationship.establish")}
                                <span className={`relationship-${relationship}`}>
                                    {t(`relationship.${relationship}`)}
                                </span>
                                {t("relationship.desc-" + applyStatus)}
                            </div>
                        )}
                        {applyStatus === "process" && (
                            <div className="relation-action-btns">
                                <Button
                                    className="btn-right"
                                    type="text"
                                    onClick={handleInvited.bind(this, "refused")}
                                >
                                    {t("relationship.refused")}
                                </Button>
                                <Button
                                    className={relationship}
                                    type="text"
                                    onClick={handleInvited.bind(this, "accept")}
                                >
                                    {t("relationship.accept")}
                                </Button>
                            </div>
                        )}
                        {applyStatus === "refused" && (
                            <div className="relation-action-status refused">
                                <CloseOutlined
                                    style={{ margin: "0 5px" }}
                                    onPointerMoveCapture={undefined}
                                    onPointerOverCapture={undefined}
                                />
                                {t("relationship.status-" + applyStatus)}
                            </div>
                        )}
                        {applyStatus === "expire" && (
                            <div className="relation-action-status expire">
                                {t("relationship.status-" + applyStatus)}
                            </div>
                        )}
                    </div>
                )}
            </div>
        );
    };

    // 引用消息内容展示
    const getReferenceMsgDisplay = (extension: any): ReactElement | null => {
        switch (extension.type) {
            case TencentCloudChat.TYPES.MSG_IMAGE: {
                return (
                    <Image
                        fallback={LoadFailPNG}
                        preview={true}
                        src={extension.payload?.imageInfoArray?.[0]?.url}
                        width={80}
                    />
                );
            }
            case TencentCloudChat.TYPES.MSG_VIDEO: {
                return (
                    <video
                        controls
                        className="msg-content video reference"
                        poster={extension.payload.snapshotUrl}
                        src={extension.payload.videoUrl}
                    >
                        不支持视频播放
                    </video>
                );
            }
            case TencentCloudChat.TYPES.MSG_CUSTOM: {
                const desc = extension.payload.description;
                switch (desc) {
                    case ICustomPayloadDescription.IntimateRelation: {
                        // const curContent = JSON.parse(extension.payload.extension);
                        return (
                            <div>
                                {/* {t("relationship.intimate-invite-reference-desc", {
                                    from: curContent.from.userName,
                                    to: curContent.to.userName,
                                    relation: curContent.relation,
                                })}
                                {t("relationship.status-" + curContent.status)} */}
                                {`[${t("chat.relationship")}${t("chat.msg")}]`}
                            </div>
                        );
                    }
                    case ICustomPayloadDescription.ChatReference: {
                        return (
                            <div className="reference-custom-content">
                                <div className="reference-desc">
                                    {extension?.payload?.text || extension?.payload?.data}
                                </div>
                            </div>
                        );
                    }
                    case ICustomPayloadDescription.Link: {
                        return (
                            <div
                                className="reference-link-message"
                                onClick={async () => {
                                    const channelSplit = extension.payload.data.split("/");
                                    const channelKey = channelSplit[channelSplit.length - 1];
                                    const checkResult = await checkInviteURL(channelKey);
                                    const channelStore = useChannelStore.getState();
                                    const { roomUUID } = useChannelRoomStore.getState();
                                    const channelId = checkResult.data as string;
                                    if (roomUUID === channelId) {
                                        eventBus.emit("show-message", {
                                            message: t("channel.already-in-channel"),
                                            type: "warning",
                                        });
                                        return;
                                    }
                                    if (checkResult.data === null) {
                                        eventBus.emit("show-message", {
                                            message: t("invalid-invite-url"),
                                            type: "warning",
                                        });
                                        return;
                                    } else if (checkResult.data === false) {
                                        eventBus.emit("show-message", {
                                            message: t("invite-url-expired"),
                                            type: "warning",
                                        });
                                        return;
                                    }
                                    if (!channelStore.channels.has(channelId)) {
                                        const result =
                                            await channelStore.queryChannelInfo(channelId);
                                        if (!result) {
                                            eventBus.emit("show-message", {
                                                message: t("channel-not-exist"),
                                                type: "warning",
                                            });
                                            return;
                                        }
                                        const channelRoomStore = useChannelRoomStore.getState();
                                        if (channelId === channelRoomStore.roomUUID) {
                                            globalStore.updateToJoinRoomUUID("");
                                        } else {
                                            globalStore.updateToJoinRoomUUID(channelId);
                                        }
                                        const realNewChannel = useChannelStore
                                            .getState()
                                            .channels.get(channelId);
                                        if (realNewChannel) {
                                            channelStore.updateActiveChannel(realNewChannel);
                                        }
                                    }
                                    const preferenceStore = getPreferencesStore(
                                        globalStore.userInfo!.user_id!,
                                    );
                                    const params: { roomUUID: string; showGuide?: boolean } = {
                                        roomUUID: channelId,
                                    };
                                    if (
                                        !channelStore.hasChannels &&
                                        preferenceStore.hasShowedChannelGuide === false
                                    ) {
                                        params.showGuide = true;
                                    }
                                    pushHistory(RouteNameType.ChannelPage, {}, params);
                                }}
                            >
                                <Typography.Text copyable={{ text: extension.payload.data }}>
                                    {extension.payload.data.replace(`${REMO_GAME_WEB_URL}#/`, "")}
                                </Typography.Text>
                            </div>
                        );
                    }
                }

                return <>{t("chat.unknown-msg-type")}</>;
            }
            default: {
                return extension?.payload?.text || extension?.payload?.data;
            }
        }
    };
    switch (type) {
        case TencentCloudChat.TYPES.MSG_TEXT: {
            msgContent = <div className="msg-content text">{payload.text}</div>;
            break;
        }
        case TencentCloudChat.TYPES.MSG_IMAGE: {
            if (isSearch) {
                const name = msg.cloudCustomData;
                msgContent = (
                    <div className="msg-content image">
                        {name ? (
                            <>
                                {t("chat.send-a-name", { user: basicInfo.fromNick })}
                                <span style={{ color: "#FEB94C" }}>{name}</span>
                            </>
                        ) : (
                            t("chat.send-an-image", { user: basicInfo.fromNick })
                        )}
                    </div>
                );
                break;
            }
            const fallback = payload?.file?.path || LoadFailPNG;
            msgContent = (
                <Image
                    className="msg-content img"
                    fallback={fallback}
                    // preview={false}
                    src={payload?.imageInfoArray?.[0]?.url}
                />
            );
            break;
        }
        case TencentCloudChat.TYPES.MSG_AUDIO: {
            msgContent = (
                <audio controls className="msg-content audio" src={payload.url}>
                    <span>{payload.second}s</span>
                </audio>
            );
            break;
        }
        case TencentCloudChat.TYPES.MSG_VIDEO: {
            if (isSearch) {
                const name = msg.cloudCustomData;
                msgContent = (
                    <div className="msg-content video">
                        {name ? (
                            <>
                                {t("chat.send-a-name", { user: basicInfo.fromNick })}
                                <span style={{ color: "#FEB94C" }}>{name}</span>
                            </>
                        ) : (
                            t("chat.send-an-video", { user: basicInfo.fromNick })
                        )}
                    </div>
                );
                break;
            }
            msgContent = (
                <video
                    controls
                    className="msg-content video"
                    poster={payload.snapshotUrl}
                    src={payload.videoUrl}
                >
                    不支持视频播放
                </video>
            );
            break;
        }
        case TencentCloudChat.TYPES.MSG_FILE: {
            msgContent = (
                <span className="msg-content file">
                    <a download={payload.fileName} href={payload.fileUrl}>
                        {payload.fileName} ({Math.round(payload.fileSize / 1024)}KB)
                    </a>
                </span>
            );
            break;
        }
        case TencentCloudChat.TYPES.MSG_CUSTOM: {
            if (payload.description === ICustomPayloadDescription.ChatReference) {
                // 兼容一下旧数据---TODO 待上线时仅保留完整的extension
                const extension = payload.extension.includes("ID")
                    ? JSON.parse(payload.extension)
                    : { ID: payload.extension };
                const referenceMsg = msgData.chatData.find(item => item.ID === extension.ID);
                if (isSearch) {
                    msgContent = (
                        <div className="msg-content reference-custom">
                            [回复消息] {payload.data}
                        </div>
                    );
                    break;
                }
                msgContent = (
                    <div className="msg-content reference-custom">
                        <div className="msg-custom">{payload.data}</div>
                        <div className="msg-reference">
                            <div style={{ marginRight: 4 }}>
                                {referenceMsg?.nick || extension?.nick}:
                            </div>
                            {getReferenceMsgDisplay(extension)}
                            {/* {extension?.type === TencentCloudChat.TYPES.MSG_IMAGE ? (
                                <Image
                                    fallback={LoadFailPNG}
                                    preview={true}
                                    src={extension.payload?.imageInfoArray?.[0]?.url}
                                    width={80}
                                />
                            ) : (
                                extension?.payload?.text || extension?.payload?.data
                            )} */}
                        </div>
                    </div>
                );
                break;
            } else if (payload.description === ICustomPayloadDescription.ChannelInteraction) {
                const isToAll = payload.extension === SpecialEffectTo.All;
                // extension改为JSON字符串对象
                let toSomeone;
                try {
                    toSomeone = JSON.parse(payload.extension);
                } catch (error) {
                    const temp = payload.extension.slice(5);
                    toSomeone = {
                        userID: temp,
                        userName: temp,
                    };
                }
                msgContent = (
                    <div
                        className="msg-content interaction-custom"
                        onClick={() => {
                            const to = isToAll ? basicInfo.to : toSomeone.userID;
                            const toName = isToAll ? t("chat.all") : toSomeone.userName;
                            eventBus.emit("replay-interaction", {
                                from: basicInfo.from,
                                to,
                                toName,
                                toType: payload.extension,
                                icon: payload.data,
                                actionID: uuidv4(),
                            });
                        }}
                    >
                        {isToAll
                            ? t("interaction-message.sendToChannel")
                            : toSomeone.userID === globalStore.userInfo?.user_id
                              ? t("interaction-message.sendToYou")
                              : t("interaction-message.sendToOther", { name: toSomeone.userName })}
                        <span className="interactionName">
                            【{t(`interaction-message.${payload.data}`)}】
                        </span>
                        {/* ——— */}
                        {/* <span>{t("interaction-message.clickToReplay")}</span> */}
                    </div>
                );
                break;
            } else if (payload.description === ICustomPayloadDescription.Link) {
                msgContent = (
                    <div
                        className="msg-content link-message"
                        onClick={async () => {
                            const channelSplit = payload.data.split("/");
                            const channelKey = channelSplit[channelSplit.length - 1];
                            const checkResult = await checkInviteURL(channelKey);
                            const channelStore = useChannelStore.getState();
                            const { roomUUID } = useChannelRoomStore.getState();
                            const channelId = checkResult.data as string;
                            if (roomUUID === channelId) {
                                eventBus.emit("show-message", {
                                    message: t("channel.already-in-channel"),
                                    type: "warning",
                                });
                                return;
                            }
                            if (checkResult.data === null) {
                                eventBus.emit("show-message", {
                                    message: t("invalid-invite-url"),
                                    type: "warning",
                                });
                                return;
                            } else if (checkResult.data === false) {
                                eventBus.emit("show-message", {
                                    message: t("invite-url-expired"),
                                    type: "warning",
                                });
                                return;
                            }
                            if (!channelStore.channels.has(channelId)) {
                                const result = await channelStore.queryChannelInfo(channelId);
                                if (!result) {
                                    eventBus.emit("show-message", {
                                        message: t("channel-not-exist"),
                                        type: "warning",
                                    });
                                    return;
                                }
                                const channelRoomStore = useChannelRoomStore.getState();
                                if (channelId === channelRoomStore.roomUUID) {
                                    globalStore.updateToJoinRoomUUID("");
                                } else {
                                    globalStore.updateToJoinRoomUUID(channelId);
                                }
                                const realNewChannel = useChannelStore
                                    .getState()
                                    .channels.get(channelId);
                                if (realNewChannel) {
                                    channelStore.updateActiveChannel(realNewChannel);
                                }
                            }
                            const preferenceStore = getPreferencesStore(
                                globalStore.userInfo!.user_id!,
                            );
                            const params: { roomUUID: string; showGuide?: boolean } = {
                                roomUUID: channelId,
                            };
                            if (
                                !channelStore.hasChannels &&
                                preferenceStore.hasShowedChannelGuide === false
                            ) {
                                params.showGuide = true;
                            }
                            pushHistory(RouteNameType.ChannelPage, {}, params);
                        }}
                    >
                        <Typography.Text copyable={{ text: payload.data }}>
                            {payload.data.replace(`${REMO_GAME_WEB_URL}#/`, "")}
                        </Typography.Text>
                    </div>
                );
                break;
            } else if (payload.description === ICustomPayloadDescription.IntimateRelation) {
                if (isSearch) {
                    let curInfo;
                    try {
                        curInfo = JSON.parse(payload.extension);
                    } catch (error) {
                        curInfo = {};
                    }
                    const { status, from } = curInfo;
                    let statusText;
                    switch (status) {
                        case "process": {
                            if (from.userID === userInfo?.user_id) {
                                statusText = t("chat.send-an-intimate-relation-from-self");
                                break;
                            }
                            statusText = t("chat.send-an-intimate-relation", {
                                user: basicInfo.fromNick,
                            });
                            break;
                        }
                        default: {
                            statusText =
                                t("chat.send-intimate-relation-pre", {
                                    user: basicInfo.fromNick,
                                }) + t(`relationship.status-${status}`);
                            break;
                        }
                    }
                    msgContent = (
                        <div className="msg-content intimate-relation-message">{statusText}</div>
                    );
                    break;
                }
                msgContent = getIntimateRelationContent();
                break;
            }
            msgContent = <span className="msg-content custom">{payload.data}</span>;
            break;
        }
        case TencentCloudChat.TYPES.MSG_MERGER: {
            msgContent = <span className="msg-content merge">{payload.title}</span>;
            break;
        }
        case TencentCloudChat.TYPES.MSG_LOCATION: {
            msgContent = <span className="msg-content location">{payload.description}</span>;
            break;
        }
        case TencentCloudChat.TYPES.MSG_FACE: {
            msgContent = (
                <span className="msg-content face">
                    <img
                        alt={`表情${payload.index}`}
                        src={`https://main.qcloudimg.com/raw/face/${payload.index}.png`}
                        style={{ width: "24px", height: "24px" }}
                    />
                </span>
            );
            break;
        }
        case TencentCloudChat.TYPES.MSG_GRP_TIP: {
            msgContent = <span className="msg-content grp_tip">{payload.data}</span>;
            break;
        }
        case TencentCloudChat.TYPES.MSG_GRP_SYS_NOTICE: {
            if (isSearch) {
                break;
            }
            console.log("payload", payload, payload.operationType === 16);
            msgContent = (
                <div className="msg-content grp_sys_notice">
                    {payload.operationType === 16 ? (
                        <span>{payload.userDefinedField}</span>
                    ) : (
                        <span>{payload.groupProfile?.groupName}</span>
                    )}
                </div>
            );
            break;
        }
        case PlaceHolderMsgType.MSG_PLACEHOLDER: {
            msgContent = (
                <span className="msg-content placeholder">
                    {payload.fileName} ({Math.round(payload.fileSize / 1024)}KB)
                    {t("chat.sending")}
                </span>
            );
            break;
        }
        default: {
            msgContent = <span className="msg-content">{t("chat.unknown-msg-type")}</span>;
        } // 处理未知类型的消息
    }

    useEffect(() => {
        const tempReaction = reactionList.get(msgID);
        setReaction(tempReaction);
    }, [reactionList.get(msgID)]);

    const handleReaction = async (reaction: string): Promise<void> => {
        if (userInfo && params.id) {
            await reactionEmoji({
                type: "C2C",
                receiverId: params.id,
                senderId: userInfo.user_id, // TODO: add userInfo.user_id
                messageId: msgID,
                emojiCode: reaction,
            });
            // updateMessageReaction(msgID, reaction, userInfo.user_id, userInfo.nickname);
        }
    };

    return isSearch || hoverWindow ? (
        <span className={"normal-msg"}>{msgContent}</span>
    ) : (
        <span className={"normal-msg"}>
            <span className="msg-body">
                {msgContent}
                {status === "fail" || status === "unSend" ? (
                    <ExclamationOutlined
                        className="send-fail-icon"
                        onPointerMoveCapture={undefined}
                        onPointerOverCapture={undefined}
                    />
                ) : null}
                {status === "sending" ? (
                    <LoadingOutlined
                        className="send-loading-icon"
                        onPointerMoveCapture={undefined}
                        onPointerOverCapture={undefined}
                    />
                ) : null}
                <div className="reaction-content">
                    {reaction &&
                        Object.keys(reaction).map(key => {
                            return (
                                <Button
                                    key={key}
                                    className="reaction-item"
                                    disabled={Boolean(
                                        params.id && blockedUsers.includes(params.id),
                                    )}
                                    type="primary"
                                    onClick={handleReaction.bind(this, key)}
                                >
                                    <span>{key}</span>
                                    <span className="reaction-number">
                                        {Object.keys(reaction[key]).length}
                                    </span>
                                </Button>
                            );
                        })}
                </div>
            </span>
        </span>
    );
};
